import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "clock-icon",
  "use": "clock-icon-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"clock-icon\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.103 0h7.803C15.957 0 18 2.141 18 5.327v7.353c0 3.178-2.043 5.32-5.094 5.32H5.103C2.052 18 0 15.858 0 12.68V5.327C0 2.141 2.052 0 5.103 0Zm7.119 12.43c.225 0 .45-.118.576-.334a.67.67 0 0 0-.234-.927L9.36 9.261V5.102a.675.675 0 1 0-1.35 0v4.546c0 .234.126.46.333.576l3.528 2.106a.631.631 0 0 0 .35.1Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol